import { FC, PropsWithChildren, useState, useMemo } from 'react';

import { useInteractiveCallback } from '@/hook/useInteractiveCallback';

import { AppModalContext, AppModalData } from './AppModal.context';
import { AppModal } from './AppModal';

type AppModalProviderProps = PropsWithChildren<{}>;

export const AppModalProvider: FC<AppModalProviderProps> = ({ children }) => {
    const [modalData, setModalData] = useState<AppModalData | null>(null);

    const [dialogElementRef, setDialogElementRef] =
        useState<React.RefObject<HTMLDialogElement> | null>(null);

    const setDialogRef = useInteractiveCallback(
        (ref: React.RefObject<HTMLDialogElement> | null) => {
            setDialogElementRef(ref);
        },
    );

    const contextValue = useMemo(() => {
        return {
            modalData,
            dialogElementRef,
            setModalData,
            setDialogElementRef: setDialogRef,
        };
    }, [modalData, dialogElementRef]);

    return (
        <AppModalContext.Provider value={contextValue}>
            {children}
            <AppModal />
        </AppModalContext.Provider>
    );
};
